export const HOME_FAQS = [
  {
    topic: "creation_process",
    question: "Comment fonctionne la transformation de ma photo en tableau ?",
    answer:
      "C'est simple : importez votre photo, choisissez parmi nos 16+ styles artistiques (aquarelle, peinture à l'huile, animation 3D…), notre IA génère votre œuvre personnalisée, et nous l'imprimons et vous la livrons sous 5 à 7 jours ouvrés.",
  },
  {
    topic: "available_styles",
    question: "Quels styles artistiques sont disponibles ?",
    answer:
      "Nous proposons 16+ styles : peinture à l'huile, aquarelle, impressionnisme (Monet, Van Gogh, Cézanne), crayon et esquisse, renaissance, art nouveau, surréalisme, animation 3D, anime / manga, pop art, street art, encre et sumi-e, pixel art.",
  },
  {
    topic: "delivery_timing",
    question: "Combien de temps pour recevoir mon tableau ?",
    answer:
      "Votre tableau est imprimé et livré en 5 à 7 jours ouvrés en France métropolitaine. La livraison est suivie et votre commande est emballée avec soin pour arriver en parfait état.",
  },
  {
    topic: "formats_and_sizes",
    question: "Quels formats et tailles sont disponibles ?",
    answer:
      "Plusieurs formats sont disponibles pour s'adapter à votre intérieur. Vous pouvez choisir votre format lors de la commande. Chaque commande inclut une finition premium.",
  },
  {
    topic: "gift_suitability",
    question: "Puis-je offrir ce tableau en cadeau ?",
    answer:
      "Absolument. Nos tableaux personnalisés sont des cadeaux originaux et uniques. Chaque commande est emballée avec soin, prête à offrir. Parfait pour un anniversaire, Noël, une fête des mères ou un mariage.",
  },
  {
    topic: "photo_guidance",
    question: "Quelle photo dois-je envoyer ?",
    answer:
      "Envoyez une photo nette, bien éclairée et non floue. Les portraits fonctionnent très bien — photo de famille, portrait individuel, couple ou animal de compagnie. Évitez les sujets trop petits dans l'image : plus le visage ou l'animal est visible, plus le rendu artistique sera précis.",
  },
  {
    topic: "photo_and_payment_security",
    question: "Mes photos et mon paiement sont-ils sécurisés ?",
    answer:
      "Le paiement est traité par Stripe sur une page sécurisée : Ma Photo en Tableau ne stocke pas vos coordonnées bancaires. Les photos importées servent à générer et produire votre commande, et notre politique de confidentialité détaille leur traitement.",
  },
  {
    topic: "delivery_tracking",
    question: "La livraison est-elle suivie ?",
    answer:
      "Oui, toutes les commandes sont livrées avec suivi en France et en Europe. Vous recevez un email de confirmation avec le numéro de suivi dès l'expédition.",
  },
  {
    topic: "product_difference",
    question: "Quelle est la différence avec un simple tableau photo ?",
    answer:
      "Contrairement aux services d'impression classique, notre technologie IA transforme réellement votre photo en œuvre d'art dans le style choisi. Ce n'est pas un simple filtre — c'est une véritable réinterprétation artistique de votre photo.",
  },
] as const;

export const homeFaqPageSchema = {
  "@type": "FAQPage",
  "@id": "https://www.maphotoentableau.fr/#faq",
  mainEntity: HOME_FAQS.map(({ question, answer }) => ({
    "@type": "Question",
    name: question,
    acceptedAnswer: {
      "@type": "Answer",
      text: answer,
    },
  })),
};

export const homeProductSchema = {
  "@type": "Product",
  "@id": "https://www.maphotoentableau.fr/#product",
  name: "Tableau personnalisé à partir de votre photo",
  description:
    "Transformez votre photo en tableau artistique grâce à l'IA. Choisissez parmi 16+ styles, puis commandez votre œuvre imprimée.",
  image: "https://www.maphotoentableau.fr/site-assets/hero-background.jpg",
  brand: {
    "@type": "Brand",
    name: "Ma Photo en Tableau",
  },
  offers: {
    "@type": "Offer",
    priceCurrency: "EUR",
    price: "29.99",
    priceValidUntil: "2027-12-31",
    availability: "https://schema.org/InStock",
    url: "https://www.maphotoentableau.fr",
    seller: {
      "@type": "Organization",
      name: "Ma Photo en Tableau",
      url: "https://www.maphotoentableau.fr",
    },
  },
};

export const homeStructuredDataSchema = {
  "@context": "https://schema.org",
  "@graph": [homeFaqPageSchema, homeProductSchema],
};
